(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function ($) {
  "use strict"; //Hide Loading Box (Preloader)

  function handlePreloader() {
    if ($('.preloader').length) {
      $('.preloader').delay(200).fadeOut(500);
    }
  } //Update Header Style and Scroll to Top


  function headerStyle() {
    if ($('.o-header').length) {
      var windowpos = $(window).scrollTop();
      var siteHeader = $('.o-header');
      var scrollLink = $('.scroll-top');

      if (windowpos >= 200) {
        siteHeader.addClass('fixed-header');
        scrollLink.fadeIn(300);
      } else {
        siteHeader.removeClass('fixed-header');
        scrollLink.fadeOut(300);
      }
    }
  }

  headerStyle(); //Submenu Dropdown Toggle

  if ($('.o-header li.dropdown ul').length) {
    $('.o-header li.dropdown').append('<div class="dropdown-btn"><i class="fa fa-angle-down"></i></div>'); //Dropdown Button

    $('.o-header li.dropdown .dropdown-btn').on('click', function () {
      $(this).prev('ul').slideToggle(500);
    }); //Disable dropdown parent link

    $('.o-header .navigation li.dropdown > a,.hidden-bar .side-menu li.dropdown > a').on('click', function (e) {
      e.preventDefault();
    });
  } //Progress Bar


  if ($('.progress-line').length) {
    $('.progress-line').appear(function () {
      var el = $(this);
      var percent = el.data('width');
      $(el).css('width', percent + '%');
    }, {
      accY: 0
    });
  } //Make Content Sticky


  if ($('.sticky-box').length) {
    var a = new StickySidebar('.sidebar-page-container', {
      topSpacing: 80,
      bottomSpacing: 0,
      containerSelector: '.sticky-container',
      innerWrapperSelector: '.sticky-box',
      resizeSensor: false
    });
  } //Custom Seclect Box


  if ($('.custom-select-box').length) {
    $('.custom-select-box').selectmenu().selectmenu('menuWidget').addClass('overflow');
  } //Gallery Filters


  if ($('.filter-list').length) {
    $('.filter-list').mixItUp({});
  } //Fact Counter + Text Count


  if ($('.count-box').length) {
    $('.count-box').appear(function () {
      var $t = $(this),
          n = $t.find(".count-text").attr("data-stop"),
          r = parseInt($t.find(".count-text").attr("data-speed"), 10);

      if (!$t.hasClass("counted")) {
        $t.addClass("counted");
        $({
          countNum: $t.find(".count-text").text()
        }).animate({
          countNum: n
        }, {
          duration: r,
          easing: "linear",
          step: function step() {
            $t.find(".count-text").text(Math.floor(this.countNum));
          },
          complete: function complete() {
            $t.find(".count-text").text(this.countNum);
          }
        });
      }
    }, {
      accY: 0
    });
  } //Main Slider Carousel


  if ($('.slider-carousel').length) {
    $('.slider-carousel').owlCarousel({
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
      loop: true,
      margin: 0,
      nav: true,
      autoHeight: true,
      smartSpeed: 500,
      autoplay: true,
      autoplayTimeout: 10000,
      navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        800: {
          items: 1
        },
        1024: {
          items: 1
        },
        1200: {
          items: 1
        }
      }
    });
  } // Single Item Carousel


  if ($('.single-item-carousel').length) {
    $('.single-item-carousel').owlCarousel({
      loop: true,
      margin: 0,
      nav: true,
      smartSpeed: 500,
      autoplay: 5000,
      navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        800: {
          items: 1
        },
        1024: {
          items: 1
        },
        1200: {
          items: 1
        }
      }
    });
  } // Two Item Carousel


  if ($('.two-item-carousel').length) {
    $('.two-item-carousel').owlCarousel({
      loop: true,
      margin: 30,
      nav: true,
      autoHeight: true,
      smartSpeed: 500,
      autoplay: 5000,
      navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 2
        },
        800: {
          items: 2
        },
        1024: {
          items: 2
        },
        1200: {
          items: 2
        }
      }
    });
  } //Three Item Carousel


  if ($('.three-item-carousel').length) {
    $('.three-item-carousel').owlCarousel({
      loop: true,
      margin: 30,
      nav: true,
      autoHeight: true,
      smartSpeed: 500,
      autoplay: 5000,
      navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        800: {
          items: 2
        },
        1024: {
          items: 2
        },
        1200: {
          items: 3
        }
      }
    });
  } // Four Item Carousel


  if ($('.four-item-carousel').length) {
    $('.four-item-carousel').owlCarousel({
      loop: true,
      margin: 30,
      nav: true,
      autoHeight: true,
      smartSpeed: 500,
      autoplay: 5000,
      navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 2
        },
        800: {
          items: 3
        },
        1024: {
          items: 3
        },
        1200: {
          items: 4
        }
      }
    });
  } //Experts Carousel


  if ($('.experts-carousel').length) {
    $('.experts-carousel').owlCarousel({
      loop: true,
      margin: 30,
      nav: true,
      smartSpeed: 500,
      autoplay: 5000,
      navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
      responsive: {
        0: {
          items: 1
        },
        600: {
          items: 1
        },
        800: {
          items: 2
        },
        1024: {
          items: 2
        },
        1200: {
          items: 3
        }
      }
    });
  } //LightBox / Fancybox


  if ($('.lightbox-image').length) {
    $('.lightbox-image').fancybox({
      openEffect: 'fade',
      closeEffect: 'fade',
      helpers: {
        media: {}
      }
    });
  } // Scroll to a Specific Div


  if ($('.scroll-target').length) {
    $(".scroll-target").on('click', function () {
      var target = $(this).attr('data-target'); // animate

      $('html, body').animate({
        scrollTop: $(target).offset().top
      }, 1500);
    });
  } // Elements Animation


  if ($('.wow').length) {
    var wow = new WOW({
      boxClass: 'wow',
      // animated element css class (default is wow)
      animateClass: 'animated',
      // animation css class (default is animated)
      offset: 0,
      // distance to the element when triggering the animation (default is 0)
      mobile: true,
      // trigger animations on mobile devices (default is true)
      live: true // act on asynchronously loaded content (default is true)

    });
    wow.init();
  }
  /* ==========================================================================
     When document is Scrollig, do
     ========================================================================== */


  $(window).on('scroll', function () {
    headerStyle();
  });
  /* ==========================================================================
     When document is loading, do
     ========================================================================== */

  $(window).on('load', function () {
    handlePreloader(); // enableMasonry();
  });
})(window.jQuery);

jQuery(document).ready(function () {
  initMap();
});

function initMap() {
  var div_map = jQuery('#map');

  if (div_map.length === 0) {
    return;
  } // Creating map options


  var mapOptions = {
    center: maps_configuration.latLng,
    zoom: 18,
    preferCanvas: true
  }; // Creating a map object

  var map = new L.map('map', mapOptions);
  var icon = L.icon({
    iconUrl: maps_configuration.icon,
    iconSize: [32, 32]
  });
  var marker = new L.marker([maps_configuration.lat, maps_configuration.lng], {
    icon: icon
  }); // Creating a Layer object

  var layer = new L.TileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', {
    attribution: maps_configuration.map_attribution
  }); // Adding layer to the map

  marker.addTo(map);
  map.addLayer(layer);
}

},{}]},{},[1]);
